export default "__VITE_ASSET__8a0b6184__"